import React, { useState } from 'react';
import { Index, Configure } from 'react-instantsearch-dom';

import DesktopOnly from 'components/consumer/DesktopOnly';
import useAllOptions from 'data-hooks/useAllOptions';
import StaticProductResults from '../../instant-search/components/StaticProductResults';
import SearchDesktopSidebarHeader from './SearchDesktopSidebarHeader';

const SearchProductsContent = ({
  colorFiltered,
  hitsPerPage,
  inactive,
  indexName,
  invalidProductIds,
  onIndexChange,
  onSortOrderChange,
  onToggleQuickshipFilter,
  resetAlgoliaFilters,
  removeProductIdFromList,
  searchState,
  searchStateQuery,
  setActiveAlgoliaFilter,
  setInactive,
  sortOrder,
  toggleIsSearchOpen,
  updateInvalidProductIds,
  loadRest,
}) => {
  const [productsLoading, setProductsLoading] = useState(false);
  const [lastQuery, setLastQuery] = useState('');
  const [lastQueryTopThreeRes, setLastQueryTopThreeRes] = useState([]);
  const allOptionsData = useAllOptions();

  return (
    <Index indexName={indexName}>
      <Configure
        query={searchStateQuery}
        hitsPerPage={hitsPerPage}
        facetFilters={searchState.configure?.facetFilters || ''}
        numericFilters={['item_availability<2', 'visibility>0', 'visibility<4']}
        attributesToRetrieve={[
          '_highlightResult',
          'product_id',
          'name',
          'is_in_stock',
        ]}
      />

      <StaticProductResults
        allOptionsData={allOptionsData}
        attribute="type"
        colorFiltered={colorFiltered}
        inactive={inactive}
        invalidProductIds={invalidProductIds}
        lastQuery={lastQuery}
        lastQueryTopThreeRes={lastQueryTopThreeRes}
        layout="minimal"
        limit={500}
        loadingMore={productsLoading}
        onSortOrderChange={onSortOrderChange}
        onToggleQuickshipFilter={onToggleQuickshipFilter}
        optionState="allOpts"
        removeProductIdFromList={removeProductIdFromList}
        resetAlgoliaFilters={resetAlgoliaFilters}
        searchState={searchState}
        searchStateQuery={searchStateQuery}
        setActiveAlgoliaFilter={setActiveAlgoliaFilter}
        setInactive={setInactive}
        setLastQuery={setLastQuery}
        setLastQueryTopThreeRes={setLastQueryTopThreeRes}
        setLoading={setProductsLoading}
        loadRest={loadRest}
        hitsPerPage={hitsPerPage}
        sidebarHeader={
          <DesktopOnly>
            <SearchDesktopSidebarHeader
              index={indexName}
              onIndexChange={onIndexChange}
              searchState={searchState}
            />
          </DesktopOnly>
        }
        sortOrder={sortOrder}
        toggleSearchOpen={toggleIsSearchOpen}
        updateInvalidProductIds={updateInvalidProductIds}
        variant="advanced-search"
      />
    </Index>
  );
};

export default SearchProductsContent;
